/**
 * Omhulsel van de pagina's buiten Vandaag en Klanten (sessie 46, B6).
 *
 * Tot sessie 9U zette dit omhulsel de copiloot rechts naast Kennis,
 * Gezondheid, Beheer, Signalen, Voorraad en Mijn profiel. Besluit JP 05-11
 * (D20): de copiloot staat alleen nog op Vandaag (zaakscherm) en Klanten
 * (klantkaart), waar JP mail, chat en WhatsApp beantwoordt. Hier blijft
 * alleen de pagina over; het omhulsel blijft staan zodat de pagina's niet
 * elk aangepast hoeven te worden, en meldt nog wel welke pagina open is.
 */
import type { ReactNode } from "react";

import { useKijktMee } from "./kijktMee";

import "./copiloot.css";

export function MetCopiloot({
  pagina,
  children,
}: {
  /** De sleutel van de pagina: "kennis", "gezondheid", "beheer", ... */
  pagina: string;
  children: ReactNode;
}) {
  useKijktMee("pagina", null, pagina);
  // Zelfde hoogte en scroll als voorheen, alleen zonder de tweede kolom.
  return (
    <div className="wp-met-cp wp-zonder-cp">
      <div className="wp-met-cp-inhoud">{children}</div>
    </div>
  );
}
